/* eslint-disable @typescript-eslint/no-unused-vars */
import {IAchieveData, IAchieveIconSource, ACHIEVE_ICON_SOURCE} from '@/interface';
import {getAchieveSvg} from '../utils';
import classNames from 'classnames';
import styles from './index.module.scss';

interface IAchieveDialog {
    level: IAchieveData['level'];
    type: IAchieveData['type'];
    isNoHave?: boolean;
    source?: IAchieveIconSource | string;
    className?: string;
    isExposed?: boolean;
}

export default (props: IAchieveDialog) => {
    const {level, type, source, isNoHave, className, isExposed} = props;
    return (
        <div className={className}>
            <img
                // style={{width: `${size}px`, height: `${size}px`}}
                className={classNames(
                    source === ACHIEVE_ICON_SOURCE.achieveBtn && styles.achieveBtn,
                    source === ACHIEVE_ICON_SOURCE.dialogLevel && styles.dialogLevel,
                    source === ACHIEVE_ICON_SOURCE.dialogLarge && styles.dialogLarge,
                    source === ACHIEVE_ICON_SOURCE.exposedIcon && styles.exposedIcon,
                    source === ACHIEVE_ICON_SOURCE.exposedTopIcon && styles.exposedTopIcon
                )}
                src={getAchieveSvg(level, type, isNoHave, isExposed)}
            />
        </div>
    );
};

